module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_6_m.b77defa6a6d9d176dc708fca5be2c811.png";